<template>
  <div class="page">
    <!-- 头部 -->
    <Header title="订单详情"  :leftHandler="onClickLeft" />
    <div class="content ">
      <div class="backToHome text-center" @click="backToHome">
        <van-icon :name="$getImgUrl( '/wx-app-v2/img/home/tabs-home-active@2x.png')" size="0.8rem"></van-icon>
      </div>
      <!-- 订单状态 -->
      <div class="order-detail-type text-center">
        <van-icon :name="$getImgUrl('/wx-app-v2/img/order-accomplished@2x.png')" size="1rem"></van-icon>
        <div v-if="baseInfo.orderStatus === '10'">
          <div class="order-detail-type-name">订单未发货</div>
          <div class="order-detail-type-info">正在火速处理订单，请耐心等待！</div>
        </div>
        <div v-if="['20', '30', '40'].includes(baseInfo.orderStatus)">
          <div class="order-detail-type-name">订单发货中</div>
          <div class="order-detail-type-info">发货中</div>
        </div>
        <div v-if="baseInfo.orderStatus === '50'">
          <div class="order-detail-type-name">订单已完成</div>
          <div class="order-detail-type-info">已送达</div>
        </div>
        <div v-if="baseInfo.orderStatus === '90'">
          <div class="order-detail-type-name">订单已取消</div>
          <div class="order-detail-type-info">已取消</div>
        </div>
        <div v-if="baseInfo.orderStatus === '35'">
          <div class="order-detail-type-name">订单已退回</div>
          <div class="order-detail-type-info">已退回</div>
        </div>
      </div>
      <!-- 物流状态 -->
      <template v-for="item in logisticsOption">
        <van-cell :title="item.title" :key="item.title"
          :is-link="baseInfo.orderStatus !== '10' && baseInfo.orderStatus !== '90'"
          v-if="item.orderStatus.includes(baseInfo.orderStatus)"
          @click="viewLogisticsInformation(baseInfo.orderId, item.hasClick)">
          <template #icon>
            <van-icon style="margin-right: 0.5rem;" :name="getBannerMobileImageUri('/img/logistics-icon@2x.png')"
              size="0.55rem"></van-icon>
          </template>
        </van-cell>
      </template>
      <AddressInfo :selectAddress="baseInfo" @refreshData="init"></AddressInfo>
      <div v-if="orderInfo.couponInfo" class="coupon-info">
        <p class="themecolor">优惠券</p>
        <p v-if="orderInfo.couponInfo.couponType === '03'">使用卡券&nbsp;&nbsp;&nbsp;×{{ orderInfo.couponInfo.couponCount }}张
        </p>
        <p v-if="orderInfo.couponInfo.couponType !== '03'">卡券码&nbsp;&nbsp;&nbsp;{{ orderInfo.couponInfo.couponCode }}</p>
        <p>卡券内容&nbsp;&nbsp;&nbsp;{{ orderInfo.couponInfo.couponDesc }}</p>
      </div>
      <div class="margin-x-2">
        <div class="row">
          <p>订单编号</p>
          <!-- <p>订单状态</p> -->
          <p>创建时间</p>
        </div>
        <div class="row">
          <p>{{ baseInfo.orderNumber }}</p>
          <!-- <p> {{ baseInfo.orderStatusName }}</p> -->
          <p>{{ baseInfo.createDate | parseTime('{y}-{m}-{d}') }}</p>
        </div>
      </div>
      <div v-for="(detailItem, index) in detailList" :key="index">
          <OrderDetailBox :detailItem="detailItem" :orderInfo="orderInfo" :isElearningCourse="isElearningCourse" height="2rem"
          @cancelOrder="orderCancel(detailItem.itemId, detailItem.orderDetailId)"
          @openElearning="openElearning(detailItem.itemId, detailItem.orderDetailId)"></OrderDetailBox>
      </div>
      <div class="remind-send" v-if="baseInfo.orderStatus == '10'">
        <van-button type="primary" plain @click="remindDelivery">提醒发货</van-button>
      </div>
    </div>
        <!-- 活动弹窗 -->
        <popUpDisplay :show.sync="popUpDisplay.dialog"  :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type" ></popUpDisplay>
  </div>
</template>

<script>
import wxAppApi from '@/api/wx-app'
import Header from '@/components/header'
import AddressInfo from '@/components/address-info'
import OrderDetailBox from './component/order-detail-box.vue'
import { mapState } from 'vuex'
import popUpDisplay from '../../components/popup-cards.vue'

export default {
  components: {
    Header,
    AddressInfo,
    OrderDetailBox,
    popUpDisplay
  },
  data () {
    return {
      orderId: null,
      choosedPiece: '',
      filePrefix: '',
      orderInfo: {},
      logisticsOption: [{
        title: '物流信息：未更新',
        orderStatus: ['10', '20'],
        hasClick: false
      }, {
        title: '物流信息：发货中',
        orderStatus: ['30', '40'],
        hasClick: true
      }, {
        title: '物流信息：已退回',
        orderStatus: ['35'],
        hasClick: true
      }, {
        title: '物流信息：已送达',
        orderStatus: ['50'],
        hasClick: true
      }, {
        title: '物流信息：已取消',
        orderStatus: ['190'],
        hasClick: false
      }],
      selectAddress: {},
      baseInfo: {},
      detailList: [],
      activityPrize: {},
      popUpDisplay: {
        dialog: false,
        activityPrize: {},
        type: ''
      }
    }
  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有查看订单详情的权限')
    } else {
      this.init()
      if (this.activityPrize) {
        if (this.activityPrize.clientAction === '05') {
          this.popUpDisplay.type = 'exchange'
        } else {
          this.popUpDisplay.type = 'order'
        }
        console.log(this.popUpDisplay.type, 'this.popUpDisplay.type')
        this.popUpDisplay.dialog = true
        this.popUpDisplay.activityPrize = this.activityPrize
      }
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    isElearningCourse () {
      return this.orderInfo && this.orderInfo.detailList[0] && ((this.orderInfo.detailList[0].itemCategoryCode && this.orderInfo.detailList[0].itemCategoryCode === '13003') || this.orderInfo.detailList[0].itemCategoryCode === '501')
    }
  },
  methods: {
    init () {
      this.orderId = this.$route.params.orderId
      this.activityPrize = this.$route.params.activityPrize
      this.isUserCoupon = this.$route.params.isUserCoupon
      this.hasActivityBonus = this.$route.params.hasActivityBonus
      this.activityPieceCodes = this.$route.params.activityPieceCodes
      this.form = this.$route.params.form
      this.filePrefix = this.$store.state.base.ApiEndpoint.fileUrl
      this.getOrderInfo()
    },
    getOrderInfo () {
      let params = {
        orderId: this.orderId
      }
      wxAppApi.queryItemInfo(params).then(res => {
        if (res.data.resultCode === '0') {
          const { orderInfo } = res.data.resultData
          const { baseInfo, detailList } = orderInfo
          this.orderInfo = orderInfo
          this.baseInfo = baseInfo
          this.detailList = detailList
          let orderStatus = orderInfo.baseInfo.orderStatus
          if (orderStatus === '10') {
            if (this.hasActivityBonus) {
              // 2021中秋返积分活动（返积分弹窗在领碎片的弹窗后面）
              // let midAutumnValue = localStorage.getItem('midAutumnValue')
              if (localStorage.getItem('midAutumnValue')) {
                // midAutumnPopup(midAutumnValue)
              }
            }
          // 订单刚创建
          } else if (orderStatus === '20' || orderStatus === '30') {
            // 发货中
          } else if (orderStatus === '50') {
            // 已送达
          } else if (orderStatus === '90') {
            // 特殊状态，只有当订单内的礼品全部被取消时会出现
          }
        }
      })
    },
    // 提醒发货
    remindDelivery () {
      this.$toast('提醒发货成功')
    },
    viewLogisticsInformation (orderId, hasClick) {
      if (hasClick) {
        this.$router.push({
          name: 'logistics-view',
          query: {
            orderId: orderId
          }
        })
      }
    },
    getBannerMobileImageUri (mobileImageUri) {
      return process.env.VUE_APP_EXTRA_SITE + mobileImageUri
    },
    orderCancel (itemId, orderDetailId) {
      this.$router.push({
        name: 'orderCancel',
        params: {
          itemId: itemId,
          orderId: this.orderId,
          orderDetailId: orderDetailId
        }
      })
    },
    openElearning (itemId, orderDetailId) {
      this.$router.push({
        name: 'knowledge-goods',
        params: {
          itemId: itemId,
          orderDetailId: orderDetailId
        }
      })
    },
    backToHome () {
      this.$router.push({ name: 'home-main' })
    },
    onClickLeft () {
      this.$router.push({
        name: 'userOrder'
      })
    }
  }
}
</script>
<style scoped lang="less">
.content {
  position: relative;

  .backToHome {
    position: absolute;
    top: 0.3rem;
    left: 0.3rem;
    z-index: 9;
  }

  .order-detail-type {
    padding: 0.5rem;
    background-color: #fff;
    margin-bottom: 0.3rem;
  }

  .order-detail-type-name {
    margin-top: 0.3rem;
    margin-bottom: 0.2rem;
    color: #005961;
    font-size: 0.5rem;
  }

  .order-detail-type-info {
    color: #c2c2c2;
    font-size: 0.35rem;
  }

  .container {
    padding: 0 0.3rem;
  }

  .coupon-info {
    padding: 0 0.3rem;
    font-size: 0.35rem;

    p {
      padding: 0.1rem 0rem;
    }
  }

  .row {
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0.1rem 0rem;
    font-size: 0.35rem;

    p {
      flex: 0 0 50%
    }
  }

  .remind-send {
    width: 100%;
    padding: 0.2rem 0rem;
    background-color: #fff;
    text-align: center;
  }
}
.margin-x-2 {
  margin: 0.2rem 0rem;
}
</style>
